// extracted by mini-css-extract-plugin
module.exports = {"label-text":"LabelText_label-text__ss__o"};